import isTransparent from "./is-transparent";

const hasDesign = (
  {objects = [], background = `transparent`} = {
    objects: [],
    background: `transparent`
  }
) => {
  const isEmpty = objects && !objects.length;
  return !(isEmpty && isTransparent(background));
};

export default hasDesign;
